// extracted by mini-css-extract-plugin
export default {"container":"LangSwitch_container__Jych0","select":"LangSwitch_select__BO0Ij","option":"LangSwitch_option__9uOg1"};